module.exports = __webpack_public_path__ + "img/sergeant-tips-icon1.5128d19c.png";